import React, { useState } from "react"
import Image from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Image"
import Button from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Button"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faTimes,
  faPhone,
  faPhoneAlt,
  faFax,
  faAt,
} from "@fortawesome/pro-solid-svg-icons"

const ScrollContactBlock = ({ block, maincontact, contacts, buttons }) => {
  const [contactOpenState, setContactOpenState] = useState(false)

  const contactOpenHandler = () => {
    if (contactOpenState === false) {
      setContactOpenState(true)
    } else {
      setContactOpenState(false)
    }
  }

  return (
    <>
      <section
        className={`fixed bottom-0 border-primary border-t-2 left-0 right-0 z-40 transition-all duration-500 transform ${
          contactOpenState === true ? "" : "translate-y-full"
        } bg-white`}
      >
        <div className="py-block block-w-container">
          <div className="flex flex-row flex-wrap -mx-grid">
            <div className="w-full mb-4 md:w-1/2 lg:w-1/3 px-grid">
              {maincontact && (
                <div className="block">
                  {maincontact?.content?.image && (
                    <div className="w-40 mb-8 xpx-24">
                      <Image
                        image={maincontact.content.image}
                        className="w-full h-auto rounded-full"
                        aspectRatio="1by1"
                      />
                    </div>
                  )}
                  <div className="xtext-center">
                    {maincontact?.content?.name && (
                      <span className="block text-xl font-bold">
                        {maincontact.content.name}
                      </span>
                    )}
                    {maincontact?.content?.description && (
                      <span className="block mb-2 text-lg">
                        {maincontact.content.description}
                      </span>
                    )}
                    {maincontact?.content?.tel && (
                      <a
                        className="block mb-2 text-lg text-primary hover:text-primary-hover"
                        href={"tel:" + maincontact.content.tel}
                      >
                        <FontAwesomeIcon
                          icon={faPhoneAlt}
                          size="1x"
                          className="mr-1"
                        />
                        {maincontact.content.tel}
                      </a>
                    )}
                    {maincontact?.content?.fax && (
                      <span className="block mb-2 text-lg">
                        <FontAwesomeIcon
                          icon={faFax}
                          size="1x"
                          className="mr-1"
                        />
                        {maincontact.content.fax}
                      </span>
                    )}
                    {maincontact?.content?.email && (
                      <a
                        className="block mb-2 text-lg text-primary hover:text-primary-hover"
                        href={"mailto:" + maincontact.content.email}
                      >
                        <FontAwesomeIcon
                          icon={faAt}
                          size="1x"
                          className="mr-1"
                        />
                        {maincontact.content.email}
                      </a>
                    )}
                  </div>
                </div>
              )}
            </div>
            <div className="w-full md:w-1/2 lg:w-1/3 px-grid">
              {contacts &&
                contacts.length > 0 &&
                contacts.map((item, index) => (
                  <div
                    key={index}
                    className="flex flex-row flex-wrap mb-4 -mx-grid"
                  >
                    <div className="mb-4 w-28 xw-1/4 px-grid">
                      {item?.content?.image && (
                        <Image
                          image={item.content.image}
                          className="w-full h-auto rounded-full "
                          aspectRatio="1by1"
                        />
                      )}
                    </div>
                    <div className="w-auto xw-3/4 px-grid">
                      {item?.name && (
                        <span className="block text-lg font-bold">
                          {item.name}
                        </span>
                      )}
                      {item?.content?.description && (
                        <span className="block">
                          {item.content.description}
                        </span>
                      )}
                      {item?.content?.tel && (
                        <a
                          className="block text-primary hover:text-primary-hover"
                          href={"tel:" + item.content.tel}
                        >
                          <FontAwesomeIcon
                            icon={faPhoneAlt}
                            size="1x"
                            className="mr-1"
                          />
                          {item.content.tel}
                        </a>
                      )}
                      {item?.content?.fax && (
                        <span className="block">
                          <FontAwesomeIcon
                            icon={faFax}
                            size="1x"
                            className="mr-1"
                          />
                          {item.content.fax}
                        </span>
                      )}
                      {item?.content?.email && (
                        <a
                          className="block text-primary hover:text-primary-hover"
                          href={"mailto:" + item.content.email}
                        >
                          <FontAwesomeIcon
                            icon={faAt}
                            size="1x"
                            className="mr-1"
                          />
                          {item.content.email}
                        </a>
                      )}
                    </div>
                  </div>
                ))}
            </div>
            <div className="w-full lg:border-primary lg:border-l-2 lg:w-1/3 px-grid">
              <div className="block w-full pt-4 border-t-2 lg:pt-0 border-primary lg:border-t-0">
                {buttons.map((button, index) => (
                  <div className="block md:inline-block md:mr-4 lg:mr-0 lg:block">
                    <Button
                      className="mb-4"
                      btnType={index > 0 ? "secondary" : "primary"}
                      link={button.link}
                      target={button.target}
                      key={index}
                      icon={button.icon}
                    >
                      {button.link_text}
                    </Button>
                  </div>
                ))}
                <div className="block md:inline-block lg:block">
                  <Button
                    className=""
                    btnType="primary"
                    link="https://www.google.de"
                  >
                    Programm 2021
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="fixed bottom-0 right-0 z-50 inline-block p-4">
        <button
          className="py-4 btn btn-primary"
          onClick={() => contactOpenHandler()}
        >
          {contactOpenState === false ? (
            <FontAwesomeIcon icon={faPhone} size="1x" className="block" />
          ) : (
            <FontAwesomeIcon icon={faTimes} className="block fa-w-16" />
          )}
        </button>
      </div>
    </>
  )
}

export default ScrollContactBlock
